import React, {

    useEffect,

    useMemo,

    useState

} from 'react';



import {

    Alert,

    Button,

    Card,

    Col,

    Input,

    InputNumber,

    Row,

    Statistic,

    Table,

    message,

    Space

} from 'antd';



import {

    FileExcelOutlined,

    FilePdfOutlined,

    ReloadOutlined,

    SaveOutlined,

    PlusOutlined

} from '@ant-design/icons';



import * as XLSX from 'xlsx';



import jsPDF from 'jspdf';

import autoTable from 'jspdf-autotable';



import {

    getKermesDashboard,

    getKermesCashClosing,

    saveKermesCashClosing

} from '../utils/api';





/*

 * ==========================================

 * DENOMINACIONES

 * ==========================================

 */



const DENOMINATIONS = [



    {

        value: 1000,

        label: '$1,000',

        type: 'Billete'

    },



    {

        value: 500,

        label: '$500',

        type: 'Billete'

    },



    {

        value: 200,

        label: '$200',

        type: 'Billete'

    },



    {

        value: 100,

        label: '$100',

        type: 'Billete'

    },



    {

        value: 50,

        label: '$50',

        type: 'Billete'

    },



    {

        value: 20,

        label: '$20',

        type: 'Billete'

    },



    {

        value: 10,

        label: '$10',

        type: 'Moneda'

    },



    {

        value: 5,

        label: '$5',

        type: 'Moneda'

    },



    {

        value: 2,

        label: '$2',

        type: 'Moneda'

    },



    {

        value: 1,

        label: '$1',

        type: 'Moneda'

    },



    {

        value: 0.5,

        label: '$0.50',

        type: 'Moneda'

    }



];





/*

 * ==========================================

 * ARQUEO VACÍO

 * ==========================================

 */



const EMPTY_CASH_BREAKDOWN = {



    1000: 0,

    500: 0,

    200: 0,

    100: 0,

    50: 0,

    20: 0,

    10: 0,

    5: 0,

    2: 0,

    1: 0,

    0.5: 0



};





export default function KermesCorte({
    apiBase = '/api/kermes',
    userId = null
}) {



    // =========================

    // ESTADOS

    // =========================



    const [data, setData] =

        useState(null);



    const [loading, setLoading] =

        useState(false);



    /*

     * Total de efectivo contado.

     * Ahora se obtiene automáticamente

     * del arqueo.

     */

    const [cashReceived, setCashReceived] =

        useState(0);



    /*

     * Cantidad de cada denominación.

     */

    const [

        cashBreakdown,

        setCashBreakdown

    ] = useState({

        ...EMPTY_CASH_BREAKDOWN

    });



    /*

     * Observaciones.

     */

    const [notes, setNotes] =

        useState('');



    /*

     * Corte guardado en BD.

     */

    const [

        savedClosing,

        setSavedClosing

    ] = useState(null);



    /*

     * Guardando corte.

     */

    const [

        savingClosing,

        setSavingClosing

    ] = useState(false);





    // =========================

    // CARGAR DASHBOARD

    // =========================



    const loadDashboard = async () => {



        setLoading(true);



        try {



            const result =

                await getKermesDashboard();



            if (!result.success) {



                throw new Error(

                    result.message ||

                    'No se pudo cargar el corte.'

                );



            }



            setData(result);



        } catch (error) {



            message.error(

                error.message

            );



        } finally {



            setLoading(false);



        }



    };





    // =========================

    // CARGAR CORTE GUARDADO

    // =========================



    const loadCashClosing = async () => {



        try {



            const result =

                await getKermesCashClosing();





            if (result.closing) {



                setSavedClosing(

                    result.closing

                );



                setCashReceived(

                    Number(

                        result.closing

                            .cash_received || 0

                    )

                );



                setNotes(

                    result.closing.notes || ''

                );





                /*

                 * Reconstruir arqueo.

                 */



                const restoredBreakdown = {

                    ...EMPTY_CASH_BREAKDOWN

                };





                (

                    result.closing

                        .breakdown || []

                ).forEach(item => {



                    restoredBreakdown[

                        Number(

                            item.denomination

                        )

                    ] =

                        Number(

                            item.quantity || 0

                        );



                });





                setCashBreakdown(

                    restoredBreakdown

                );



            } else {



                setSavedClosing(null);



                setCashReceived(0);



                setNotes('');



                setCashBreakdown({

                    ...EMPTY_CASH_BREAKDOWN

                });



            }





        } catch (error) {



            message.error(

                error.message

            );



        }



    };





    // =========================

    // ACTUALIZAR TODO

    // =========================



    const refreshAll = async () => {



        await Promise.all([



            loadDashboard(),



            loadCashClosing()



        ]);



    };





    // =========================

    // CARGA INICIAL

    // =========================



    useEffect(() => {



        loadDashboard();



        loadCashClosing();



    }, []);





    // =========================

    // INGRESOS DEL SISTEMA

    // =========================



    const systemRevenue =

        Number(

            data?.summary?.revenue || 0

        );





    // =========================

    // TOTAL DEL ARQUEO

    // =========================



    const calculatedCash =

        useMemo(() => {



            const total =

                DENOMINATIONS.reduce(

                    (

                        accumulator,

                        denomination

                    ) => {



                        const quantity =

                            Number(

                                cashBreakdown[

                                    denomination.value

                                ] || 0

                            );



                        return (

                            accumulator +

                            (

                                denomination.value *

                                quantity

                            )

                        );



                    },

                    0

                );





            return Number(

                total.toFixed(2)

            );



        }, [

            cashBreakdown

        ]);





    /*

     * Mientras no exista un corte

     * guardado, el efectivo recibido

     * sigue el arqueo.

     */



    useEffect(() => {



        if (!savedClosing) {



            setCashReceived(

                calculatedCash

            );



        }



    }, [

        calculatedCash,

        savedClosing

    ]);





    // =========================

    // DIFERENCIA PROVISIONAL

    // =========================



    const difference =

        useMemo(() => {



            const cashCents =

                Math.round(

                    Number(

                        cashReceived || 0

                    ) * 100

                );



            const systemCents =

                Math.round(

                    Number(

                        systemRevenue || 0

                    ) * 100

                );





            return (

                cashCents -

                systemCents

            ) / 100;



        }, [

            cashReceived,

            systemRevenue

        ]);





    // =========================

    // VALORES PARA REPORTE

    // =========================



    const reportSystemRevenue =

        savedClosing



            ? Number(

                savedClosing

                    .system_revenue || 0

            )



            : systemRevenue;





    const reportCashReceived =

        savedClosing



            ? Number(

                savedClosing

                    .cash_received || 0

            )



            : cashReceived;





    const reportDifference =

        savedClosing



            ? Number(

                savedClosing

                    .difference || 0

            )



            : difference;





    // =========================

    // ARQUEO PARA REPORTES

    // =========================



    const reportBreakdown =

        useMemo(() => {



            /*

             * Si el corte ya está guardado,

             * usamos exactamente lo

             * almacenado en BD.

             */



            if (

                savedClosing?.breakdown?.length

            ) {



                return savedClosing

                    .breakdown

                    .map(item => ({



                        denomination:

                            Number(

                                item.denomination

                            ),



                        quantity:

                            Number(

                                item.quantity || 0

                            ),



                        subtotal:

                            Number(

                                item.subtotal || 0

                            )



                    }));



            }





            /*

             * Si todavía no está guardado,

             * construimos el reporte con

             * el arqueo actual.

             */



            return DENOMINATIONS.map(

                denomination => {



                    const quantity =

                        Number(

                            cashBreakdown[

                                denomination.value

                            ] || 0

                        );





                    return {



                        denomination:

                            denomination.value,



                        quantity,



                        subtotal:

                            Number(

                                (

                                    denomination.value *

                                    quantity

                                ).toFixed(2)

                            )



                    };



                }

            );



        }, [

            savedClosing,

            cashBreakdown

        ]);





    // =========================

    // CAMBIAR DENOMINACIÓN

    // =========================



    const handleCashQuantityChange = (

        denomination,

        value

    ) => {



        if (savedClosing) {



            return;



        }





        const quantity =

            Math.max(

                0,

                Number(value || 0)

            );





        setCashBreakdown(

            previous => ({



                ...previous,



                [denomination]:

                    quantity



            })

        );



    };





    // =========================

    // GUARDAR CORTE

    // =========================



    const saveClosing = async () => {



        if (calculatedCash <= 0) {



            message.warning(

                'Realiza primero el conteo del efectivo.'

            );



            return;



        }





        setSavingClosing(true);





        try {



            /*

             * Mandamos las cantidades.

             *

             * PHP vuelve a calcular

             * subtotales y total.

             */



            const cash_breakdown =

                DENOMINATIONS.map(

                    denomination => ({



                        denomination:

                            denomination.value,



                        quantity:

                            Number(

                                cashBreakdown[

                                    denomination.value

                                ] || 0

                            )



                    })

                );





            const result =

                await saveKermesCashClosing({



                    user_id:

                        userId ||

                        localStorage.getItem(

                            'user_id'

                        ),



                    cash_breakdown,



                    notes:

                        notes.trim() ||

                        null



                });





            if (!result.success) {



                throw new Error(

                    result.message ||

                    'No se pudo guardar el corte.'

                );



            }





            setSavedClosing(

                result.closing

            );





            setCashReceived(

                Number(

                    result.closing

                        .cash_received || 0

                )

            );





            setNotes(

                result.closing.notes || ''

            );





            /*

             * Actualizamos el desglose

             * con lo que devolvió PHP.

             */



            if (

                result.closing

                    .breakdown?.length

            ) {



                const restored = {

                    ...EMPTY_CASH_BREAKDOWN

                };





                result.closing

                    .breakdown

                    .forEach(item => {



                        restored[

                            Number(

                                item.denomination

                            )

                        ] =

                            Number(

                                item.quantity || 0

                            );



                    });





                setCashBreakdown(

                    restored

                );



            }





            message.success(

                'Corte de caja guardado correctamente.'

            );





        } catch (error) {



            message.error(

                error.message

            );





        } finally {



            setSavingClosing(false);



        }



    };





    // =========================

    // NUEVO CORTE

    // =========================

    const handleNewClosing = async () => {

        /*
         * Conservamos el corte anterior en la BD,
         * pero liberamos el formulario para capturar
         * un nuevo arqueo.
         */

        setSavedClosing(null);

        setCashReceived(0);

        setNotes('');

        setCashBreakdown({
            ...EMPTY_CASH_BREAKDOWN
        });

        /*
         * Actualizamos el dashboard para que React
         * trabaje con los datos más recientes.
         * No llamamos loadCashClosing(), porque eso
         * volvería a cargar y bloquear el último corte.
         */

        await loadDashboard();

        message.info('Nuevo corte listo para capturar.');

    };

// =========================
// EXPORTAR A PDF
// =========================

const exportPDF = () => {

    if (!data) return;

    const summary = data.summary;

    const doc = new jsPDF();

    const fecha = new Date();

    const fechaTexto = fecha.toLocaleString(
        'es-MX',
        {
            dateStyle: 'long',
            timeStyle: 'short'
        }
    );


    // =========================
    // DATOS GENERALES
    // =========================

    const systemRevenue =
        Number(summary.revenue || 0);

    const totalClosings =
        Number(summary.total_closings || 0);

    const totalCashReceived =
        Number(summary.total_cash_received || 0);

    const totalDifference =
        Number(summary.total_difference || 0);

    const lastClosingCash =
        Number(savedClosing?.cash_received || 0);

    const lastClosingDifference =
        Number(savedClosing?.difference || 0);


    // =========================
    // TÍTULO
    // =========================

    doc.setFontSize(18);

    doc.text(
        'CORTE DE CAJA - KERMÉS',
        14,
        20
    );


    doc.setFontSize(10);

    doc.text(
        `Generado: ${fechaTexto}`,
        14,
        28
    );


    // =========================
    // RESUMEN GENERAL
    // =========================

    doc.setFontSize(13);

    doc.text(
        'Resumen general de la operación',
        14,
        40
    );


    const resumenBody = [

        [
            'Ventas válidas',
            summary.valid_orders
        ],

        [
            'Ventas canceladas',
            summary.cancelled_orders
        ],

        [
            'Pedidos',
            summary.total_preorders
        ],

        [
            'Pedidos entregados',
            summary.delivered_preorders
        ],

        [
            'Pedidos pendientes',
            summary.pending_preorders
        ],

        [
            'Pedidos cancelados',
            summary.cancelled_preorders
        ],

        [
            'Piezas vendidas',
            summary.total_items
        ],

        [
            'Ingresos registrados',
            `$${systemRevenue.toFixed(2)}`
        ],

        [
            'Cortes realizados',
            totalClosings
        ],

        [
            'Efectivo acumulado',
            `$${totalCashReceived.toFixed(2)}`
        ],

        [
            'Diferencia acumulada',
            `${totalDifference > 0 ? '+' : ''}$${totalDifference.toFixed(2)}`
        ]

    ];


    autoTable(doc, {

        startY: 45,

        head: [[
            'Concepto',
            'Cantidad'
        ]],

        body: resumenBody,

        theme: 'grid',

        styles: {
            fontSize: 10
        }

    });


    // =========================
    // CONCILIACIÓN ACUMULADA
    // =========================

    const conciliacionY =
        doc.lastAutoTable.finalY + 12;


    doc.setFontSize(13);

    doc.text(
        'Conciliación acumulada',
        14,
        conciliacionY
    );


    autoTable(doc, {

        startY:
            conciliacionY + 5,

        head: [[
            'Concepto',
            'Importe'
        ]],

        body: [

            [
                'Ingreso registrado en sistema',
                `$${systemRevenue.toFixed(2)}`
            ],

            [
                'Efectivo acumulado en cortes',
                `$${totalCashReceived.toFixed(2)}`
            ],

            [
                'Diferencia acumulada',
                `${totalDifference > 0 ? '+' : ''}$${totalDifference.toFixed(2)}`
            ]

        ],

        theme: 'grid',

        styles: {
            fontSize: 10
        }

    });


    // =========================
    // ÚLTIMO CORTE
    // =========================

    if (savedClosing) {

        const ultimoCorteY =
            doc.lastAutoTable.finalY + 12;


        doc.setFontSize(13);

        doc.text(
            'Último corte realizado',
            14,
            ultimoCorteY
        );


        autoTable(doc, {

            startY:
                ultimoCorteY + 5,

            head: [[
                'Dato',
                'Valor'
            ]],

            body: [

                [
                    'ID del corte',
                    savedClosing.id || '-'
                ],

                [
                    'Fecha del corte',
                    savedClosing.created_at || '-'
                ],

                [
                    'Efectivo contado',
                    `$${lastClosingCash.toFixed(2)}`
                ],

                [
                    'Diferencia registrada en el corte',
                    `${lastClosingDifference > 0 ? '+' : ''}$${lastClosingDifference.toFixed(2)}`
                ]

            ],

            theme: 'grid',

            styles: {
                fontSize: 10
            }

        });

    }


    // =========================
    // DESGLOSE DEL ÚLTIMO CORTE
    // =========================

    const usedBreakdown =
        Array.isArray(reportBreakdown)

            ? reportBreakdown.filter(
                item =>
                    Number(
                        item.quantity
                    ) > 0
            )

            : [];


    if (
        savedClosing &&
        usedBreakdown.length > 0
    ) {

        const arqueoY =
            doc.lastAutoTable.finalY + 12;


        doc.setFontSize(13);

        doc.text(
            'Desglose del último corte',
            14,
            arqueoY
        );


        autoTable(doc, {

            startY:
                arqueoY + 5,

            head: [[
                'Denominación',
                'Cantidad',
                'Subtotal'
            ]],

            body:
                usedBreakdown.map(
                    item => [

                        `$${Number(
                            item.denomination
                        ).toFixed(2)}`,

                        Number(
                            item.quantity
                        ),

                        `$${Number(
                            item.subtotal
                        ).toFixed(2)}`

                    ]
                ),

            foot: [[

                'TOTAL',

                '',

                `$${lastClosingCash.toFixed(2)}`

            ]],

            theme: 'grid',

            styles: {
                fontSize: 10
            }

        });

    }


    // =========================
    // OBSERVACIONES DEL CORTE
    // =========================

    const reportNotes =
        savedClosing?.notes ||
        notes ||
        '';


    if (
        savedClosing &&
        reportNotes
    ) {

        const notesY =
            doc.lastAutoTable.finalY + 12;


        doc.setFontSize(13);

        doc.text(
            'Observaciones del último corte',
            14,
            notesY
        );


        doc.setFontSize(10);


        const noteLines =
            doc.splitTextToSize(
                reportNotes,
                175
            );


        doc.text(
            noteLines,
            14,
            notesY + 6
        );


        /*
         * Dejamos espacio después
         * de las observaciones.
         */

        doc.lastAutoTable.finalY =
            notesY +
            8 +
            (
                noteLines.length * 5
            );

    }


    // =========================
    // PRODUCTOS VENDIDOS
    // =========================

    const productosY =
        doc.lastAutoTable.finalY + 15;


    doc.setFontSize(13);

    doc.text(
        'Productos vendidos',
        14,
        productosY
    );


    autoTable(doc, {

        startY:
            productosY + 5,

        head: [[
            'Producto',
            'Vendidos'
        ]],

        body:
            data.products.map(
                product => [

                    product.name,

                    Number(
                        product.sold_quantity || 0
                    )

                ]
            ),

        theme: 'grid',

        styles: {
            fontSize: 10
        }

    });


    // =========================
    // PEDIDOS ANTICIPADOS
    // =========================

    const preorderY =
        doc.lastAutoTable.finalY + 15;


    doc.setFontSize(13);

    doc.text(
        'Pedidos anticipados entregados',
        14,
        preorderY
    );


    autoTable(doc, {

        startY:
            preorderY + 5,

        head: [[
            'Producto',
            'Cantidad'
        ]],

        body:
            data.products.map(
                product => [

                    product.name,

                    Number(
                        product.preorder_quantity || 0
                    )

                ]
            ),

        theme: 'grid',

        styles: {
            fontSize: 10
        }

    });


    // =========================
    // DESGLOSE DE INGRESOS
    // =========================

    const ingresosY =
        doc.lastAutoTable.finalY + 15;


    doc.setFontSize(13);

    doc.text(
        'Desglose de ingresos registrados',
        14,
        ingresosY
    );


    autoTable(doc, {

        startY:
            ingresosY + 5,

        head: [[
            'Origen',
            'Importe'
        ]],

        body: [

            [
                'Ventas normales',
                `$${Number(
                    summary.normal_revenue || 0
                ).toFixed(2)}`
            ],

            [
                'Pedidos anticipados entregados',
                `$${Number(
                    summary.preorder_revenue || 0
                ).toFixed(2)}`
            ],

            [
                'TOTAL REGISTRADO',
                `$${systemRevenue.toFixed(2)}`
            ]

        ],

        theme: 'grid',

        styles: {
            fontSize: 10
        }

    });


    // =========================
    // PEDIDOS PENDIENTES
    // =========================

    if (
        Number(
            summary.pending_preorders || 0
        ) > 0
    ) {

        const pendientesY =
            doc.lastAutoTable.finalY + 15;


        doc.setFontSize(13);

        doc.text(
            'Pedidos pendientes',
            14,
            pendientesY
        );


        autoTable(doc, {

            startY:
                pendientesY + 5,

            head: [[
                'Concepto',
                'Valor'
            ]],

            body: [

                [
                    'Pedidos pendientes',
                    Number(
                        summary.pending_preorders || 0
                    )
                ],

                [
                    'Piezas pendientes',
                    Number(
                        summary.pending_preorder_items || 0
                    )
                ],

                [
                    'Importe pendiente',
                    `$${Number(
                        summary.pending_preorder_total || 0
                    ).toFixed(2)}`
                ]

            ],

            theme: 'grid',

            styles: {
                fontSize: 10
            }

        });

    }


    // =========================
    // PIE DE PÁGINA
    // =========================

    const pageCount =
        doc.internal
            .getNumberOfPages();


    for (
        let i = 1;
        i <= pageCount;
        i++
    ) {

        doc.setPage(i);

        doc.setFontSize(8);

        doc.text(
            `Página ${i} de ${pageCount}`,
            14,
            doc.internal
                .pageSize
                .height - 10
        );

    }


    // =========================
    // GUARDAR PDF
    // =========================

    const fechaArchivo =
        fecha
            .toISOString()
            .slice(0, 10);


    doc.save(
        `corte-caja-kermes-${fechaArchivo}.pdf`
    );

};



    // =========================
// EXPORTAR A EXCEL
// =========================

const exportExcel = () => {

    if (!data) return;

    const summary = data.summary;


    // =========================
    // DATOS GENERALES
    // =========================

    const systemRevenue =
        Number(summary.revenue || 0);

    const totalClosings =
        Number(summary.total_closings || 0);

    const totalCashReceived =
        Number(summary.total_cash_received || 0);

    const totalDifference =
        Number(summary.total_difference || 0);

    const lastClosingCash =
        Number(savedClosing?.cash_received || 0);

    const lastClosingDifference =
        Number(savedClosing?.difference || 0);


    // =========================
    // RESUMEN GENERAL
    // =========================

    const summaryData = [

        [
            'CORTE DE CAJA - KERMÉS'
        ],

        [
            'Generado',
            new Date().toLocaleString(
                'es-MX',
                {
                    dateStyle: 'long',
                    timeStyle: 'short'
                }
            )
        ],

        [],

        [
            'RESUMEN GENERAL DE LA OPERACIÓN'
        ],

        [],

        [
            'Concepto',
            'Cantidad'
        ],

        [
            'Ventas válidas',
            Number(
                summary.valid_orders || 0
            )
        ],

        [
            'Ventas canceladas',
            Number(
                summary.cancelled_orders || 0
            )
        ],

        [
            'Pedidos',
            Number(
                summary.total_preorders || 0
            )
        ],

        [
            'Pedidos entregados',
            Number(
                summary.delivered_preorders || 0
            )
        ],

        [
            'Pedidos pendientes',
            Number(
                summary.pending_preorders || 0
            )
        ],

        [
            'Pedidos cancelados',
            Number(
                summary.cancelled_preorders || 0
            )
        ],

        [
            'Piezas vendidas',
            Number(
                summary.total_items || 0
            )
        ],

        [
            'Ingresos registrados',
            systemRevenue
        ],

        [
            'Cortes realizados',
            totalClosings
        ],

        [
            'Efectivo acumulado',
            totalCashReceived
        ],

        [
            'Diferencia acumulada',
            totalDifference
        ]

    ];


    // =========================
    // CONCILIACIÓN ACUMULADA
    // =========================

    const reconciliationData = [

        [],

        [
            'CONCILIACIÓN ACUMULADA'
        ],

        [],

        [
            'Concepto',
            'Importe'
        ],

        [
            'Ingreso registrado en sistema',
            systemRevenue
        ],

        [
            'Efectivo acumulado en cortes',
            totalCashReceived
        ],

        [
            'Diferencia acumulada',
            totalDifference
        ]

    ];


    // =========================
    // ÚLTIMO CORTE
    // =========================

    const lastClosingData =
        savedClosing

            ? [

                [],

                [
                    'ÚLTIMO CORTE REALIZADO'
                ],

                [],

                [
                    'Dato',
                    'Valor'
                ],

                [
                    'ID del corte',
                    savedClosing.id
                ],

                [
                    'Fecha del corte',
                    savedClosing.created_at || ''
                ],

                [
                    'Efectivo contado',
                    lastClosingCash
                ],

                [
                    'Diferencia registrada en el corte',
                    lastClosingDifference
                ],

                [
                    'Observaciones',
                    savedClosing.notes ||
                    notes ||
                    'Sin observaciones'
                ]

            ]

            : [];


    // =========================
    // DESGLOSE DEL ÚLTIMO CORTE
    // =========================

    const usedBreakdown =
        Array.isArray(reportBreakdown)

            ? reportBreakdown.filter(
                item =>
                    Number(
                        item.quantity
                    ) > 0
            )

            : [];


    const cashBreakdownData =
        savedClosing &&
        usedBreakdown.length > 0

            ? [

                [],

                [
                    'DESGLOSE DEL ÚLTIMO CORTE'
                ],

                [],

                [
                    'Denominación',
                    'Cantidad',
                    'Subtotal'
                ],

                ...usedBreakdown.map(
                    item => [

                        Number(
                            item.denomination
                        ),

                        Number(
                            item.quantity
                        ),

                        Number(
                            item.subtotal
                        )

                    ]
                ),

                [
                    'TOTAL',
                    '',
                    lastClosingCash
                ]

            ]

            : [];


    // =========================
    // PRODUCTOS VENDIDOS
    // =========================

    const productsData = [

        [],

        [
            'PRODUCTOS VENDIDOS'
        ],

        [],

        [
            'Producto',
            'Vendidos'
        ],

        ...data.products.map(
            product => [

                product.name,

                Number(
                    product.sold_quantity || 0
                )

            ]
        )

    ];


    // =========================
    // PEDIDOS ANTICIPADOS
    // =========================

    const preorderData = [

        [],

        [
            'PEDIDOS ANTICIPADOS ENTREGADOS'
        ],

        [],

        [
            'Producto',
            'Cantidad'
        ],

        ...data.products.map(
            product => [

                product.name,

                Number(
                    product.preorder_quantity || 0
                )

            ]
        )

    ];


    // =========================
    // DESGLOSE DE INGRESOS
    // =========================

    const revenueData = [

        [],

        [
            'DESGLOSE DE INGRESOS REGISTRADOS'
        ],

        [],

        [
            'Origen',
            'Importe'
        ],

        [
            'Ventas normales',
            Number(
                summary.normal_revenue || 0
            )
        ],

        [
            'Pedidos anticipados entregados',
            Number(
                summary.preorder_revenue || 0
            )
        ],

        [
            'TOTAL REGISTRADO',
            systemRevenue
        ]

    ];


    // =========================
    // PEDIDOS PENDIENTES
    // =========================

    const pendingData =
        Number(
            summary.pending_preorders || 0
        ) > 0

            ? [

                [],

                [
                    'PEDIDOS PENDIENTES'
                ],

                [],

                [
                    'Concepto',
                    'Valor'
                ],

                [
                    'Pedidos pendientes',
                    Number(
                        summary.pending_preorders || 0
                    )
                ],

                [
                    'Piezas pendientes',
                    Number(
                        summary.pending_preorder_items || 0
                    )
                ],

                [
                    'Importe pendiente',
                    Number(
                        summary.pending_preorder_total || 0
                    )
                ]

            ]

            : [];


    // =========================
    // CREAR HOJA
    // =========================

    const worksheet =
        XLSX.utils.aoa_to_sheet([

            ...summaryData,

            ...reconciliationData,

            ...lastClosingData,

            ...cashBreakdownData,

            ...productsData,

            ...preorderData,

            ...revenueData,

            ...pendingData

        ]);


    // =========================
    // ANCHO DE COLUMNAS
    // =========================

    worksheet['!cols'] = [

        {
            wch: 40
        },

        {
            wch: 28
        },

        {
            wch: 20
        }

    ];


    // =========================
    // FORMATO MONEDA
    // =========================

    /*
     * Buscamos las celdas numéricas que
     * representan importes y les damos
     * formato monetario de Excel.
     */

    const range =
        XLSX.utils.decode_range(
            worksheet['!ref']
        );


    for (
        let row = range.s.r;
        row <= range.e.r;
        row++
    ) {

        for (
            let col = range.s.c;
            col <= range.e.c;
            col++
        ) {

            const cellAddress =
                XLSX.utils.encode_cell({
                    r: row,
                    c: col
                });


            const cell =
                worksheet[cellAddress];


            if (
                !cell ||
                typeof cell.v !== 'number'
            ) {

                continue;

            }


            /*
             * Recuperamos el texto de la
             * primera columna de la fila.
             */

            const conceptCell =
                worksheet[
                    XLSX.utils.encode_cell({
                        r: row,
                        c: 0
                    })
                ];


            const concept =
                String(
                    conceptCell?.v || ''
                ).toLowerCase();


            /*
             * Campos monetarios.
             */

            const isMoney =
                concept.includes('ingreso') ||
                concept.includes('efectivo') ||
                concept.includes('diferencia') ||
                concept.includes('importe') ||
                concept.includes('subtotal') ||
                concept.includes('total registrado');


            if (isMoney) {

                cell.z =
                    '$#,##0.00;-$#,##0.00';

            }

        }

    }


    // =========================
    // CREAR LIBRO
    // =========================

    const workbook =
        XLSX.utils.book_new();


    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        'Corte de Caja'
    );


    // =========================
    // GUARDAR
    // =========================

    const fecha =
        new Date()
            .toISOString()
            .slice(0, 10);


    XLSX.writeFile(
        workbook,
        `corte-caja-kermes-${fecha}.xlsx`
    );

};


    // =========================

    // LOADING

    // =========================



    if (!data) {



        return (



            <Card

                loading={loading}

            />



        );



    }





    // =========================

    // RENDER

    // =========================



    return (



        <>



            {/* =========================

                CORTE DE CAJA

            ========================= */}



            <Card>



                {/* ENCABEZADO */}



                <div

                    style={{

                        display: 'flex',

                        justifyContent: 'space-between',

                        alignItems: 'center',

                        gap: 12,

                        flexWrap: 'wrap',

                        marginBottom: 20

                    }}

                >



                    <div>



                        <div

                            style={{

                                fontSize: 18,

                                fontWeight: 600

                            }}

                        >

                            Corte de caja

                        </div>



                        <div

                            style={{

                                fontSize: 13,

                                color: '#8c8c8c',

                                marginTop: 2

                            }}

                        >

                            Resumen general de la Kermés

                        </div>



                    </div>





                    <Space

                        wrap

                        size={[8, 8]}

                    >



                        <Button

                            icon={

                                <ReloadOutlined />

                            }

                            onClick={

                                refreshAll

                            }

                            loading={

                                loading

                            }

                        >

                            Actualizar

                        </Button>





                        <Button

                            color="green"

                            icon={

                                <FileExcelOutlined />

                            }

                            onClick={

                                exportExcel

                            }

                            variant="outlined"

                        >

                            Excel

                        </Button>





                        <Button

                            danger

                            icon={

                                <FilePdfOutlined />

                            }

                            onClick={

                                exportPDF

                            }

                        >

                            PDF

                        </Button>



                    </Space>



                </div>





                {/* =========================

                    INGRESOS DEL SISTEMA

                ========================= */}



                <Card

                    size="small"

                    style={{

                        marginBottom: 16

                    }}

                >



                    <Statistic

                        title="Ingresos registrados"

                        prefix="$"

                        value={

                            systemRevenue

                        }

                        precision={2}

                        styles={{

                            content: {

                                color: '#3f8600',

                                fontSize: 32,

                                fontWeight: 600

                            }

                        }}

                    />



                </Card>





              {/* =========================
    CONCILIACIÓN
========================= */}

<Card
    size="small"
    title="Conciliación de efectivo"
    style={{
        marginBottom: 16
    }}
>

    {/* CORTE GUARDADO */}

    {savedClosing && (

        <Alert
            type="success"
            showIcon
            message={`Corte #${savedClosing.id} guardado correctamente`}
            description={
                savedClosing.created_at
                    ? `Registrado el ${savedClosing.created_at}. El corte ya forma parte de la conciliación acumulada.`
                    : 'El corte ya forma parte de la conciliación acumulada.'
            }
            style={{
                marginBottom: 20
            }}
        />

    )}


    {/* =========================
        CONCILIACIÓN ACUMULADA
    ========================= */}

    <div
        style={{
            marginBottom: 8,
            fontSize: 16,
            fontWeight: 600
        }}
    >
        Acumulado de la operación
    </div>

    <div
        style={{
            marginBottom: 16,
            fontSize: 13,
            color: '#8c8c8c'
        }}
    >
        Comparación entre los ingresos registrados y todos los cortes de efectivo realizados.
    </div>


    <Row gutter={[16, 16]}>

        {/* SISTEMA */}

        <Col
            xs={24}
            md={8}
        >

            <Card
                size="small"
                style={{
                    height: '100%'
                }}
            >

                <Statistic
                    title="Registrado en sistema"
                    prefix="$"
                    value={
                        Number(
                            data?.summary?.revenue || 0
                        )
                    }
                    precision={2}
                />

            </Card>

        </Col>


        {/* EFECTIVO ACUMULADO */}

        <Col
            xs={24}
            md={8}
        >

            <Card
                size="small"
                style={{
                    height: '100%'
                }}
            >

                <Statistic
                    title="Efectivo acumulado"
                    prefix="$"
                    value={
                        Number(
                            data?.summary?.total_cash_received || 0
                        )
                    }
                    precision={2}
                    styles={{
                        content: {
                            color: '#1677ff',
                            fontWeight: 600
                        }
                    }}
                />

                <div
                    style={{
                        marginTop: 4,
                        fontSize: 12,
                        color: '#8c8c8c'
                    }}
                >
                    {
                        Number(
                            data?.summary?.total_closings || 0
                        )
                    } {
                        Number(
                            data?.summary?.total_closings || 0
                        ) === 1
                            ? 'corte realizado'
                            : 'cortes realizados'
                    }
                </div>

            </Card>

        </Col>


        {/* DIFERENCIA ACUMULADA */}

        <Col
            xs={24}
            md={8}
        >

            <Card
                size="small"
                style={{
                    height: '100%'
                }}
            >

                <Statistic
                    title="Diferencia acumulada"
                    prefix={
                        Number(
                            data?.summary?.total_difference || 0
                        ) > 0

                            ? '+$'

                            : Number(
                                data?.summary?.total_difference || 0
                            ) < 0

                                ? '-$'

                                : '$'
                    }
                    value={
                        Math.abs(
                            Number(
                                data?.summary?.total_difference || 0
                            )
                        )
                    }
                    precision={2}
                    styles={{
                        content: {

                            color:
                                Number(
                                    data?.summary?.total_difference || 0
                                ) > 0

                                    ? '#1677ff'

                                    : Number(
                                        data?.summary?.total_difference || 0
                                    ) < 0

                                        ? '#cf1322'

                                        : '#3f8600',

                            fontWeight: 600

                        }
                    }}
                />

            </Card>

        </Col>

    </Row>


    {/* =========================
        RESULTADO ACUMULADO
    ========================= */}

    {
        Number(
            data?.summary?.total_closings || 0
        ) > 0 && (

            <Alert
                showIcon
                style={{
                    marginTop: 16
                }}
                type={
                    Number(
                        data?.summary?.total_difference || 0
                    ) > 0

                        ? 'info'

                        : Number(
                            data?.summary?.total_difference || 0
                        ) < 0

                            ? 'warning'

                            : 'success'
                }
                message={

                    Number(
                        data?.summary?.total_difference || 0
                    ) > 0

                        ? `Hay $${Number(
                            data?.summary?.total_difference || 0
                        ).toFixed(2)} más en efectivo acumulado que lo registrado.`

                        : Number(
                            data?.summary?.total_difference || 0
                        ) < 0

                            ? `Hay $${Math.abs(
                                Number(
                                    data?.summary?.total_difference || 0
                                )
                            ).toFixed(2)} menos en efectivo acumulado que lo registrado.`

                            : 'El efectivo acumulado coincide exactamente con el sistema.'
                }
                description={

                    Number(
                        data?.summary?.total_difference || 0
                    ) > 0

                        ? 'La diferencia puede corresponder a ventas realizadas fuera del sistema.'

                        : Number(
                            data?.summary?.total_difference || 0
                        ) < 0

                            ? 'Conviene revisar ventas, pedidos, cancelaciones y movimientos de efectivo.'

                            : 'No existe diferencia entre los cortes registrados y los ingresos del sistema.'
                }
            />

        )
    }


    {/* =========================
        ARQUEO
    ========================= */}

    <div
        style={{
            marginTop: 28
        }}
    >

        <div
            style={{
                fontSize: 16,
                fontWeight: 600,
                marginBottom: 4
            }}
        >
            {
                savedClosing
                    ? 'Último arqueo realizado'
                    : 'Nuevo arqueo de efectivo'
            }
        </div>


        <div
            style={{
                fontSize: 13,
                color: '#8c8c8c',
                marginBottom: 16
            }}
        >
            {
                savedClosing

                    ? 'Este es el desglose del último corte guardado. Puedes iniciar un nuevo corte para registrar más efectivo.'

                    : 'Ingresa la cantidad de cada billete o moneda encontrada en este corte.'
            }
        </div>


        <Row gutter={[12, 12]}>

            {DENOMINATIONS.map(
                denomination => {

                    const quantity =
                        Number(
                            cashBreakdown[
                                denomination.value
                            ] || 0
                        );


                    const subtotal =
                        denomination.value *
                        quantity;


                    return (

                        <Col
                            xs={24}
                            sm={12}
                            md={8}
                            lg={6}
                            key={
                                denomination.value
                            }
                        >

                            <Card
                                size="small"
                                style={{
                                    height: '100%'
                                }}
                            >

                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        gap: 8,
                                        marginBottom: 10
                                    }}
                                >

                                    <div>

                                        <div
                                            style={{
                                                fontSize: 18,
                                                fontWeight: 600
                                            }}
                                        >
                                            {
                                                denomination.label
                                            }
                                        </div>

                                        <div
                                            style={{
                                                fontSize: 12,
                                                color: '#8c8c8c'
                                            }}
                                        >
                                            {
                                                denomination.type
                                            }
                                        </div>

                                    </div>


                                    <div
                                        style={{
                                            fontWeight: 600
                                        }}
                                    >
                                        $
                                        {
                                            subtotal.toLocaleString(
                                                'es-MX',
                                                {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }
                                            )
                                        }
                                    </div>

                                </div>


                                <InputNumber
                                    min={0}
                                    precision={0}
                                    controls
                                    size="large"
                                    value={
                                        quantity
                                    }
                                    disabled={
                                        !!savedClosing
                                    }
                                    onChange={
                                        value =>
                                            handleCashQuantityChange(
                                                denomination.value,
                                                value
                                            )
                                    }
                                    style={{
                                        width: '100%'
                                    }}
                                />

                            </Card>

                        </Col>

                    );

                }
            )}

        </Row>


        {/* =========================
            TOTAL DEL CORTE ACTUAL
        ========================= */}

        <Card
            size="small"
            style={{
                marginTop: 16
            }}
        >

            <Row
                gutter={[16, 8]}
                align="middle"
            >

                <Col
                    xs={24}
                    sm={12}
                >

                    <div
                        style={{
                            fontSize: 15,
                            fontWeight: 500
                        }}
                    >
                        {
                            savedClosing
                                ? 'Total del último corte'
                                : 'Total del nuevo arqueo'
                        }
                    </div>

                    <div
                        style={{
                            fontSize: 12,
                            color: '#8c8c8c'
                        }}
                    >
                        {
                            savedClosing

                                ? 'Este importe ya está incluido en el efectivo acumulado.'

                                : 'Suma automática de los billetes y monedas de este corte.'
                        }
                    </div>

                </Col>


                <Col
                    xs={24}
                    sm={12}
                >

                    <Statistic
                        prefix="$"
                        value={
                            reportCashReceived || 0
                        }
                        precision={2}
                        styles={{
                            content: {
                                fontSize: 28,
                                fontWeight: 700,
                                color: '#1677ff'
                            }
                        }}
                    />

                </Col>

            </Row>

        </Card>

    </div>


    {/* =========================
        OBSERVACIONES
    ========================= */}

    <div
        style={{
            marginTop: 20
        }}
    >

        <div
            style={{
                marginBottom: 8,
                fontWeight: 500
            }}
        >
            Observaciones del corte
        </div>


        <Input.TextArea
            rows={3}
            maxLength={500}
            showCount
            value={
                notes
            }
            disabled={
                !!savedClosing
            }
            placeholder="Ej. Se realizaron algunas ventas fuera del sistema."
            onChange={
                event =>
                    setNotes(
                        event.target.value
                    )
            }
        />

    </div>


    {/* =========================
        GUARDAR / NUEVO CORTE
    ========================= */}

    {!savedClosing ? (

        <Button
            type="primary"
            size="large"
            block
            icon={<SaveOutlined />}
            loading={savingClosing}
            disabled={
                calculatedCash <= 0
            }
            onClick={
                saveClosing
            }
            style={{
                marginTop: 20
            }}
        >
            Guardar corte de caja
        </Button>

    ) : (

        <Button
            type="primary"
            size="large"
            block
            icon={<PlusOutlined />}
            onClick={
                handleNewClosing
            }
            style={{
                marginTop: 20
            }}
        >
            Realizar nuevo corte
        </Button>

    )}

</Card>




                {/* =========================

                    ESTADÍSTICAS

                ========================= */}



                <Row

                    gutter={[12, 12]}

                >



                    <Col

                        xs={12}

                        md={6}

                    >



                        <Card

                            size="small"

                            style={{

                                height: '100%'

                            }}

                        >



                            <Statistic

                                title="Ventas válidas"

                                value={

                                    data.summary

                                        .valid_orders

                                }

                            />



                        </Card>



                    </Col>





                    <Col

                        xs={12}

                        md={6}

                    >



                        <Card

                            size="small"

                            style={{

                                height: '100%'

                            }}

                        >



                            <Statistic

                                title="Piezas"

                                value={

                                    data.summary

                                        .total_items

                                }

                            />



                        </Card>



                    </Col>





                    <Col

                        xs={12}

                        md={6}

                    >



                        <Card

                            size="small"

                            style={{

                                height: '100%'

                            }}

                        >



                            <Statistic

                                title="Pedidos"

                                value={

                                    data.summary

                                        .total_preorders

                                }

                            />



                        </Card>



                    </Col>





                    <Col

                        xs={12}

                        md={6}

                    >



                        <Card

                            size="small"

                            style={{

                                height: '100%'

                            }}

                        >



                            <Statistic

                                title="Pendientes"

                                value={

                                    data.summary

                                        .pending_preorders

                                }

                                styles={{

                                    content: {

                                        color: '#faad14'

                                    }

                                }}

                            />



                        </Card>



                    </Col>





                    <Col

                        xs={12}

                        md={6}

                    >



                        <Card

                            size="small"

                            style={{

                                height: '100%'

                            }}

                        >



                            <Statistic

                                title="Pedidos cancelados"

                                value={

                                    data.summary

                                        .cancelled_preorders

                                }

                                styles={{

                                    content: {

                                        color: '#cf1322'

                                    }

                                }}

                            />



                        </Card>



                    </Col>





                    <Col

                        xs={12}

                        md={6}

                    >



                        <Card

                            size="small"

                            style={{

                                height: '100%'

                            }}

                        >



                            <Statistic

                                title="Ventas canceladas"

                                value={

                                    data.summary

                                        .cancelled_orders

                                }

                                styles={{

                                    content: {

                                        color: '#cf1322'

                                    }

                                }}

                            />



                        </Card>



                    </Col>



                </Row>



            </Card>





            {/* =========================

                PRODUCTOS

            ========================= */}



            <Card

                style={{

                    marginTop: 16

                }}

            >



                <div

                    style={{

                        fontSize: 16,

                        fontWeight: 600,

                        marginBottom: 16

                    }}

                >

                    Productos vendidos

                </div>





                <Table

                    rowKey="product_id"

                    pagination={false}

                    dataSource={

                        data.products

                    }

                    size="middle"

                    scroll={{

                        x: 450

                    }}

                    columns={[



                        {

                            title: 'Producto',

                            dataIndex: 'name',

                            fixed: 'left',

                            width: 180

                        },



                        {

                            title: 'Vendidos',

                            dataIndex:

                                'sold_quantity',

                            width: 110,

                            align: 'center'

                        },



                        {

                            title: 'Pedidos',

                            dataIndex:

                                'preorder_quantity',

                            width: 110,

                            align: 'center'

                        }



                    ]}

                />



            </Card>



        </>



    );



}